/**
 * @generated SignedSource<<4a2a23990b9a89cb32b13c80ad71d820>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SuggestedQuestionsList_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"QuestionAnswerListItem_User">;
  readonly " $fragmentType": "SuggestedQuestionsList_User";
};
export type SuggestedQuestionsList_User$key = {
  readonly " $data"?: SuggestedQuestionsList_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestedQuestionsList_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuggestedQuestionsList_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuestionAnswerListItem_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d51a4204c3ff40f0fad03305b239f278";

export default node;
